var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',_vm._b({attrs:{"outlined":"","dense":"","hide-details":""}},'v-checkbox',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }